import { createStore } from "@stencil/store";
import { Language, LanguageResponse } from "api/model/languages";
import config from "environment/environment-config";

const headers = {
  "Content-Type": "application/json",
  Accept: "application/json",
};

interface languagesStore {
  selectedLanguage: Language;
  supportedLanguages: Language[];
  isLoading: boolean;
}

const { state } = createStore({
  selectedLanguage: null,
  supportedLanguages: [],
  isLoading: false,
} as languagesStore);

const languagesDataUrl = config.contextPath + "_ui/language-selector";

export const getLanguages: () => void = async () => {
  if (!state.isLoading) {
    state.isLoading = true;
    return fetch(languagesDataUrl, {
      method: "GET",
      headers,
    })
      .then(async (response) => {
        if (!response.ok) {
          throw new Error();
        }
        const languageResponse: LanguageResponse = await response.json();
        state.selectedLanguage = languageResponse?.selectedLanguage;
        state.supportedLanguages = languageResponse?.supportedLanguages ?? [];
      })
      .catch(handleErrors);
  }
};

const handleErrors = async () => {
  state.supportedLanguages = [];
};

export default state;
